import { render, staticRenderFns } from "./GalleryManagementMobile.vue?vue&type=template&id=a960a81a&scoped=true&"
import script from "./GalleryManagementMobile.vue?vue&type=script&lang=js&"
export * from "./GalleryManagementMobile.vue?vue&type=script&lang=js&"
import style0 from "./GalleryManagementMobile.vue?vue&type=style&index=0&id=a960a81a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a960a81a",
  null
  
)

export default component.exports